import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { NotificationEffects } from './effects/notification.effects';
import { notificationReducer } from './reducers/notification.reducer';
import { selectNotificationForPersistence } from './selectors/notification.selector';
import { NOTIFICATION_FEATURE_KEY } from './notification-collection.state';

/**
 * Registers the notification feature slice, which holds the notifications together with the status
 * this device recorded for them. `NotificationNgrxService.init()` dispatches `initNotification`;
 * `NotificationEffects` fetches from OData on every call (hydration is a warm cache, never a
 * substitute for the fetch — see `notification-collection.state.ts`), then mirrors the persisted
 * fields back to storage via the generic persistence layer so a warm cache survives app restarts
 * and participates in the concurrent-usage sync path.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(NOTIFICATION_FEATURE_KEY, notificationReducer),
        EffectsModule.forFeature([NotificationEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: NOTIFICATION_FEATURE_KEY,
                persistSelector: selectNotificationForPersistence,
            },
        },
    ],
})
export class NotificationStoreModule {}
